import * as React from "react";

export function Card(props: React.HTMLAttributes<HTMLDivElement>) {
  const { className = "", ...rest } = props;
  return (
    <div
      className={
        "rounded-2xl border bg-white dark:bg-zinc-900 text-zinc-900 dark:text-zinc-100 shadow-sm " +
        className
      }
      {...rest}
    />
  );
}

export function CardContent(props: React.HTMLAttributes<HTMLDivElement>) {
  const { className = "", ...rest } = props;
  return <div className={"p-4 md:p-6 " + className} {...rest} />;
}
